import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlusLargeIcon } from 'shared/components/Icons';
import { useAlert } from 'react-alert';
import { getError } from 'utils/appHelpers';
import { useSelector } from 'react-redux';
import { getPolls } from '../../actions/polls';
import Button from 'shared/components/Button';
import SwitchButton from 'shared/components/SwitchButton';
import CreatePollModal from './components/CreatePollModal';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import PollBlock from '../PollView/components/PollBlock';
import { verifyEmailModal } from 'shared/utils/productHelpers';
import { isEmailVerified } from 'app/actions/authActions';

const Polls = () => {
  const account = useSelector(state => state.account);
  const polls = useSelector(state => state.polls);
  const alert = useAlert();
  const { t } = useTranslation();
  const [openPollModal, setOpenPollModal] = useState(false);
  const [pollSwitch, setPollSwitch] = useState('all');
  const [showActivePolls, setShowActivePolls] = useState(true);

  const showMyPolls = pollSwitch === 'my';
  const pollSwitchButtons = [{ name: t('btn_my_polls'), type: 'my' }, { name: t('btn_polls'), type: 'all' }];
  const pollStatusButtons = [
    { name: t('btn_active_polls'), type: true },
    { name: t('btn_deactive_polls'), type: false },
  ];

  const getPollsData = async () => {
    try {
      await getPolls();
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const onPollCreateHandle = () => {
    if (!isEmailVerified(account)) {
      verifyEmailModal(alert, t);
      return;
    }

    setOpenPollModal(true);
  };

  useEffect(() => {
    getPollsData();
  }, []);

  const activePolls = polls ? [...polls].filter(i => i.isActive) : [];
  const resultPolls = polls
    ? showMyPolls
      ? polls.filter(i => i.isOwner && !!i.isActive === showActivePolls)
      : activePolls
    : [];

  return (
    <div className='polls-page'>
      <div className='d-flex flex-wrap align-items-center justify-content-between mb-6 mb-md-10'>
        <h1 className='mb-0'>{showMyPolls ? t('title_my_polls') : t('title_left_or_right')}</h1>
        <div className='d-flex mt-7 mt-md-0 align-items-center justify-content-start justify-content-md-end'>
          <Button
            className='btn-sm btn-outline-dark d-flex align-items-center px-8 py-2 py-md-4'
            onClick={onPollCreateHandle}
          >
            <PlusLargeIcon className='mr-5' />
            {t('btn_create_poll')}
          </Button>
          <SwitchButton
            className='ml-16'
            buttons={pollSwitchButtons}
            activeButton={pollSwitch}
            setActiveButton={setPollSwitch}
          />
        </div>
      </div>
      {showMyPolls && (
        <div>
          {pollStatusButtons.map((item, i) => {
            const isActive = showActivePolls === item.type;
            return (
              <Button
                className={`btn-sm px-0 pt-0 pb-4 mr-15 border-bottom-nav rounded-0 ${isActive ? 'text-primary' : ''}`}
                onClick={setShowActivePolls.bind(null, item.type)}
                key={i}
              >
                {item.name}
              </Button>
            );
          })}
        </div>
      )}
      <div className='mt-md-10 mt-6 row'>
        {!polls ? (
          <div className='col-12'>
            <SkeletonLoader type='list-items' count={5} />
          </div>
        ) : (
          <>
            {resultPolls.map(item => {
              return (
                <div className='col-12 col-md-6 mb-8 mb-md-16' key={item.id}>
                  <PollBlock poll={item} />
                </div>
              );
            })}
            {!resultPolls?.length && <p className='col-12 mt-3  text-center text-secondary'>{t('polls_no_result')}</p>}
          </>
        )}
      </div>
      {openPollModal && <CreatePollModal onClose={() => setOpenPollModal(false)} />}
    </div>
  );
};

export default Polls;
